import type { ReactNode } from 'react';

interface BlocoDadosProps {
  titulo: string;
  editando: boolean;
  salvando: boolean;
  salvo: boolean;
  onEditar: () => void;
  onCancelar: () => void;
  onSalvar: () => void;
  children: ReactNode;
}

export default function BlocoDados({
  titulo,
  editando,
  salvando,
  salvo,
  onEditar,
  onCancelar,
  onSalvar,
  children,
}: BlocoDadosProps) {
  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-6">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-base font-medium text-foreground-950">{titulo}</h2>

        {editando ? (
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onCancelar}
              disabled={salvando}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-secondary-600 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onSalvar}
              disabled={salvando}
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {salvando ? 'Salvando…' : 'Salvar'}
            </button>
          </div>
        ) : salvo ? (
          <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-700">
            <i className="ri-check-line" />
            Salvo
          </span>
        ) : (
          <button
            type="button"
            onClick={onEditar}
            className="cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-background-100"
          >
            Editar
          </button>
        )}
      </div>

      <div className="mt-4 space-y-4">{children}</div>
    </div>
  );
}